import React from "react";
import { useTranslation } from "react-i18next";
import QuoteChart from "./QuoteChart";
import FormatAnalysis from "./FormatAnalysis";
import TrendAlerts from "./TrendAlerts";
import MediumBreakdown from "./MediumBreakdown";

export default function ArtistQuoteDashboard({ artistName, medium }) {
  const { t } = useTranslation();

  return (
    <div className="max-w-5xl mx-auto p-6 space-y-8">
      <h2 className="text-2xl font-bold">📊 {t("artistQuoteTools.dashboard.title", { artist: artistName })}</h2>
      <TrendAlerts artistName={artistName} medium={medium} />
      <QuoteChart artistName={artistName} medium={medium} />
      <FormatAnalysis artistName={artistName} />
      <MediumBreakdown artistName={artistName} />
    </div>
  );
}
